import PropTypes from "prop-types";

import ModalCustom from "./ModalCustom";

const RemoveModal = ({
  modalIsOpen,
  setModalIsOpen,
  id,
  title,
  removeItem,
  removeLoading,
}) => {
  return (
    <ModalCustom modalIsOpen={modalIsOpen}>
      <div className='d-flex flex-row border-bottom pb-2'>
        <i className='fad fa-warning f-20 mx-2'></i>
        <span className=''>{title}</span>
      </div>
      <div className='d-flex flex-row justify-content-around my-3'>
        <button
          onClick={() => setModalIsOpen(false)}
          className='btn btn-danger w-48 f-13'
        >
          لغو
        </button>
        <button
          onClick={() => removeItem(id)}
          className='btn btn-success w-48 f-13'
        >
          {removeLoading ? (
            <div
              className='spinner-border spinner-border-sm text-white mb-1'
              role='status'
            ></div>
          ) : (
            "بله"
          )}
        </button>
      </div>
    </ModalCustom>
  );
};

RemoveModal.propType = {
  modalIsOpen: PropTypes.bool.isRequired,
  setModalIsOpen: PropTypes.func.isRequired,
  id: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  removeItem: PropTypes.func.isRequired,
  removeLoading: PropTypes.bool.isRequired,
};

export default RemoveModal;
